import { site } from "@/mocks/site-data";

export default function MobileCta() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-secondary-300 bg-background-50/95 p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] backdrop-blur-md md:hidden">
      <a
        href={site.whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-5 py-3.5 text-base font-semibold text-background-50"
      >
        <i className="ri-whatsapp-line text-lg" />
        Agendar avaliação
      </a>
    </div>
  );
}